import { Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { ENROLLMENT_SHARED_USER_TYPES } from "./core/constants/shared.access"; // Create this constant
import { HoldRestrictionGuard } from "./core/guards/hold-restriction.guard";

export const profileRoute: Routes = [
  {
    path: "my-profile",
    canActivate: [AuthGuard, HoldRestrictionGuard],
    data: {
      userTypes: ENROLLMENT_SHARED_USER_TYPES || [0, 1, 2, 3, 4, 5, 6, 7, 8],
      moduleId: "personal-info", // Add moduleId for hold restriction checking
    },
    loadComponent: () =>
      import("./student-dashboard/my-profile/my-profile.component").then(
        (m) => m.MyProfileComponent,
      ),
  },
];
